export const MESSAGE_ROLE_VALUES = [
  'system',
  'user',
  'assistant',
  'data',
] as const;

export type MessageRole = (typeof MESSAGE_ROLE_VALUES)[number];

export const MESSAGE_ROLE_LABELS: Record<MessageRole, string> = {
  system: 'System',
  user: 'User',
  assistant: 'Assistant',
  data: 'Data',
};
